import {Icon as AIcon} from 'antd';
import defaultSettings from '@/config/defaultSettings';

const Icon = AIcon.createFromIconfontCN({
    scriptUrl: defaultSettings.iconfontUrl,
});

export default Icon
